import { Features } from './admin/partneraccount/PartnerAccountFeatures';
import { ADMIN_ROLE_NAME, Permissions } from './user/UserPermissions';

const hasFleetAccess = (permissions) =>
  Permissions.VISUALIZE_FLEET.isSetOn(permissions) &&
  !Permissions.VISUALIZE_ADMIN.isSetOn(permissions);

const hasContentAccess = (permissions) =>
  Permissions.VISUALIZE_CONTENTS.isSetOn(permissions) &&
  !Permissions.VISUALIZE_ADMIN.isSetOn(permissions);

const hasUserAccess = (permissions) =>
  Permissions.VISUALIZE_USERS.isSetOn(permissions) &&
  !Permissions.VISUALIZE_ADMIN.isSetOn(permissions);

const HOME = {
  pageTitle: 'Tableau de bord',
  pageURL: '',
  isVisible: () => true,
};
const PARTNER_ACCOUNT = {
  pageTitle: 'Partenaires',
  pageURL: '/administration/gestion-espaces-partenaires',
  isVisible: ({ role }) => role === ADMIN_ROLE_NAME,
};
const GROUPED_ORDER = {
  pageTitle: 'Commandes groupées',
  pageURL: '/administration/commandes-groupees',
  isVisible: ({ role }) => role === ADMIN_ROLE_NAME,
};
const ADMIN_USERS = {
  pageTitle: 'Gestion des utilisateurs',
  pageURL: '/administration/users',
  isVisible: ({ role }) => role === ADMIN_ROLE_NAME,
};
const FLEET = {
  pageTitle: 'Liste des tablettes',
  pageURL: '/fleet',
  isVisible: ({ permissions }) => hasFleetAccess(permissions),
};
const CONTRACT = { pageTitle: 'Contrat' };
const CONTENT = {
  pageTitle: "Gestion de l'espace partenaire",
  pageURL: '/content/manager',
  isVisible: ({ permissions, selectedLink }) =>
    !Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink) &&
    hasContentAccess(permissions),
};
const NOTIFICATION = {
  pageTitle: 'Gestion des notifications',
  pageURL: '/content/notifications',
  isVisible: ({ permissions, selectedLink }) =>
    !Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink) &&
    !Features.HOROSCOPE_MANAGER.isSetOn(selectedLink) &&
    hasContentAccess(permissions),
};
const ALMANAC = {
  pageTitle: "Gestion de l'almanach",
  pageURL: '/content/almanach',
  isVisible: ({ permissions, selectedLink }) =>
    Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink) &&
    hasContentAccess(permissions),
};
const DAILY_NEWS = {
  pageTitle: 'Gestion des articles',
  pageURL: '/content/dailynews',
  isVisible: ({ permissions, selectedLink }) =>
    Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink) &&
    hasContentAccess(permissions),
};
const FICTION = {
  pageTitle: 'Gestion des fictions',
  pageURL: '/content/fictions',
  isVisible: ({ permissions, selectedLink }) =>
    Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink) &&
    hasContentAccess(permissions),
};
const QUIZ = {
  pageTitle: 'Gestion des quiz',
  pageURL: '/content/quiz',
  isVisible: ({ permissions, selectedLink }) =>
    Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink) &&
    hasContentAccess(permissions),
};
const EMAG = {
  pageTitle: 'Gestion des magazines',
  pageURL: '/content/emag',
  isVisible: ({ permissions, selectedLink }) =>
    Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink) &&
    hasContentAccess(permissions),
};
const CALENDAR = {
  pageTitle: 'Calendrier des publications',
  pageURL: '/calendrier',
  isVisible: ({ permissions }) => hasContentAccess(permissions),
};
const USER = {
  pageTitle: 'Gestion des utilisateurs',
  pageURL: '/users',
  isVisible: ({ permissions }) => hasUserAccess(permissions),
};
const PARTNER_PROFILE = {
  pageTitle: 'Gestion du profil',
  pageURL: '/partner',
  isVisible: ({ permissions, role, selectedLink }) =>
    Permissions.MANAGE_CONTENTS.isSetOn(permissions) &&
    role !== ADMIN_ROLE_NAME &&
    !Features.ADD_NOTRE_TEMPS_CONTENTS.isSetOn(selectedLink),
};
const STATISTIC = {
  pageTitle: 'Statistiques',
  pageURL: '/statistics',
  isVisible: ({ permissions, selectedLink }) =>
    Features.VIEW_STATISTICS.isSetOn(selectedLink) &&
    (Permissions.MANAGE_CONTENTS.isSetOn(permissions) ||
      Permissions.MANAGE_FLEET.isSetOn(permissions)),
};
const PROFILE = {
  pageTitle: 'Profil',
  pageURL: '/profile',
  isVisible: () => true,
};

export {
  HOME,
  PARTNER_ACCOUNT,
  GROUPED_ORDER,
  FLEET,
  CONTRACT,
  CONTENT,
  NOTIFICATION,
  PROFILE,
  USER,
  PARTNER_PROFILE,
  ALMANAC,
  DAILY_NEWS,
  FICTION,
  QUIZ,
  EMAG,
  CALENDAR,
  STATISTIC,
  ADMIN_USERS,
};
